$(() => {
  const MEDIUM_BREAKPOINT = 1024;

  const DEPRECATION_DATA = {
    'Agriculture Dive': {
      url: 'https://www.agriculturedive.com/news/agriculture-dive-to-stop-publishing-shutdown/738087/',
      date: 'Feb. 1, 2025',
    },
    'Legal Dive': {
      url: 'https://www.legaldive.com/news/legal-dive-to-stop-publishing-shutdown/739200/', // TODO Replace with actual link
      date: 'Feb. 22, 2025',
    },
  };

  const createAlertElement = () => {
    const siteData = DEPRECATION_DATA[window.siteName];
    return `
      <div class="site-alert dive-deprecated-alert">
        <div class="row">
          <div class="columns">
            <div class="site-alert__message">
              <strong>${window.siteName} will stop publishing on ${siteData.date}.</strong>
              We appreciate your readership and hope to provide you with valuable
              coverage from one of our other publications.
              <a style="text-decoration: underline;" href="${siteData.url}">
                Read more from our team.
              </a>
              <div class="site-alert__close">
                <img src="https://utilitydive.com/static/img/close-black.svg" alt="close">
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const calculatePageShift = ($alert) => {
    const baseShift = $alert.outerHeight() + 10;
    const isTopicOrNews = ['/topic/', '/news/'].some((path) => {
      return window.location.pathname.includes(path);
    });
    return isTopicOrNews ? baseShift * 0.8 : baseShift;
  };
  const handleResize = () => {
    // Remove existing alert
    $('.dive-deprecated-alert').remove();

    // Create and insert new alert
    const $container = $(window).width() <= MEDIUM_BREAKPOINT
      ? $('.site-menu')
      : $('.menu-bar');

    $container.append(createAlertElement());

    // Apply mobile styles if needed
    if ($(window).width() <= MEDIUM_BREAKPOINT) {
      $('.dive-deprecated-alert').css('margin', '0 -16px');
    }

    // Setup close handler
    // eslint-disable-next-line no-use-before-define
    setupCloseHandler();

    // Adjust page margin
    const $alert = $('.dive-deprecated-alert').last();
    const shiftAmount = calculatePageShift($alert);
    $('.page-inner-wrapper').css('margin-top', `${shiftAmount}px`);
  };

  const setupCloseHandler = () => {
    const $closeButton = $('.dive-deprecated-alert .site-alert__close');
    $closeButton.off('click').on('click', () => {
      if ($(window).scrollTop() < 80) {
        $('.page-inner-wrapper').css('margin-top', '0');
      }
      $(window).off('resize', handleResize);
      $('.site-alert').hide();
    });
  };

  // Initialize
  $(window).on('resize', handleResize);
  handleResize();
});
